import axios from 'axios';
import { getAccessTokenBrowser } from 'helpers/auth';
import { getApiUrl } from 'helpers/getApiUrl';

export type GetArrangementsResult = Array<{
	id?: number | null;
	title?: string | null;
	description?: string | null;
	series: {
		id?: number | null;
		name?: string | null;
	} | null;
	categories?: Array<{
		id?: number | null;
		name?: string | null;
		label?: string | null;
	}> | null;
	branches?: Array<{
		id?: number | null;
		name?: string | null;
		label?: string | null;
	}> | null;
	timeOverride?: string | null;
	location?: {
		id?: number | null;
		title?: string | null;
		type?: string | null;
		address?: {
			street?: string | null;
			postNumber?: string | null;
			city?: string | null;
			country?: string | null;
		} | null;
	} | null;
	start?: string | null;
	registrationDeadline?: string | null;
	url?: string | null;
}>;

export type RequestHeaders = {
	hostname: string;
	Authorization?: string;
};

export const getArrangementsAdapter = async (
	hostname: string,
	personalize = false,
	count = 3,
	impersonateId?: string,
): Promise<GetArrangementsResult> => {
	const accessToken = await getAccessTokenBrowser();
	const headers: RequestHeaders = {
		hostname,
	};
	if (accessToken) {
		headers.Authorization = 'Bearer ' + accessToken;
	}

	let apiUrl = `Arrangement/Relevant/${count}/?personalize=${personalize}`;
	if (impersonateId) {
		apiUrl += `&impersonateId=${encodeURIComponent(impersonateId)}`;
	}

	const { href } = getApiUrl(apiUrl);
	const { data: arrangements } = await axios.get<GetArrangementsResult>(href, { headers: headers });
	return arrangements;
};

export const getSignedUpArrangementsAdapter = async (hostname: string, count = 99, impersonateId?: string): Promise<GetArrangementsResult> => {
	const accessToken = await getAccessTokenBrowser();
	const headers: RequestHeaders = {
		hostname,
	};
	if (accessToken) {
		headers.Authorization = 'Bearer ' + accessToken;
	}

	let apiUrl = `Arrangement/Registered/${count}`;
	if (impersonateId) {
		apiUrl += `?impersonateId=${encodeURIComponent(impersonateId)}`;
	}

	const { href } = getApiUrl(apiUrl);
	const { data: arrangements } = await axios.get<GetArrangementsResult>(href, { headers: headers });
	return arrangements;
};
